const Plans = {
  STARTER: 'flexible',
  PREMIUM: 'premium',
  LAUNCH: 'launch',
  GROW: 'grow',
  SCALE: 'scale',
};

export default Plans;
